import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button2 } from '../../../component/Button'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { update_setting_api } from '../../../service/settings'
import { useEffect } from 'react'
import {
  faCheckCircle,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { guided_setup } from './guides'

export const GuidedSetup = ({
  settings,
  refetch,
  completed_guided_setup,
  setCompletedGuidedSetup,
  openGuide
}: any) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const updateSettingsMutation = useMutation({
    mutationFn: update_setting_api,
    onSuccess: () => {
      refetch()
    }
  })
  // const [completed_guided_setup, setCompletedGuidedSetup] = useState(['all'])
  useEffect(() => {
    if (settings?.hasOwnProperty('completed_guided_setup'))
      setCompletedGuidedSetup(
        settings?.completed_guided_setup?.split(',') || []
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings?.completed_guided_setup])
  const updateGuidedSetup = (data: string) => {
    let completed = new Set(completed_guided_setup)
    completed.add(data)
    if (completed.size === guided_setup.length) completed.add('all')
    updateSettingsMutation.mutate({
      completed_guided_setup: Array.from(completed).join(',')
    })
    navigate(guided_setup.find((g) => g.name === data)?.link || '')
  }

  return !completed_guided_setup?.includes('all') && openGuide ?
      <div className='bg-white rounded p-2 flex flex-col gap-2 h-fit mb-2'>
        <div className=' sm:flex p-1 justify-between'>
          <p className='text-lg font-medium text-left'>{t('Setup Guide')}</p>
          <div className='flex flex-col sm:flex-row sm:items-center gap-2'>
            <Button2
              title={t('Remind Me Later')}
              btnStyle='outline'
              onClick={() =>
                setCompletedGuidedSetup([...completed_guided_setup, 'all'])
              }
            />
            <Button2
              title={t('Mark As Completed')}
              onClick={() => updateGuidedSetup('all')}
            />
          </div>
        </div>
        <hr />
        {guided_setup.map((item, index) => (
          <button
            key={index}
            onClick={() => updateGuidedSetup(item.name)}
            className={`flex w-full justify-between p-3  transition-all duration-300
                    ${completed_guided_setup.includes(item.name) && 'text-primary bg-primary bg-opacity-10'}
                    rounded items-center border-b-2 border-dashed`}
          >
            <p>{t(item.title)}</p>
            <div>
              {completed_guided_setup.includes(item.name) && (
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  className='text-green-500 mr-2'
                />
              )}
              <FontAwesomeIcon icon={faChevronRight} />
            </div>
          </button>
        ))}
      </div>
    : null
}
